/* Progressive enhancement: catalog links and products remain usable without JS. */
(() => {
  'use strict';
  function initShop(root) {
    if (root.dataset.forestReady) return;
    root.dataset.forestReady = 'true';
    const tabs = [...root.querySelectorAll('[data-forest-tab]')];
    const panels = [...root.querySelectorAll('[data-forest-panel]')];
    if (!tabs.length) return;
    root.querySelector('[data-forest-tabs]').setAttribute('role', 'tablist');
    function select(index, focus = false) {
      tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        panels[i].hidden = i !== index;
      });
      if (focus) tabs[index].focus();
    }
    tabs.forEach((tab, index) => {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panels[index].id);
      panels[index].setAttribute('role', 'tabpanel');
      panels[index].setAttribute('aria-labelledby', tab.id);
      panels[index].tabIndex = 0;
      tab.addEventListener('click', event => { event.preventDefault(); select(index); });
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); select(next, true); }
      });
    });
    select(0);
    root.addEventListener('shopify:block:select', event => {
      const index = panels.findIndex(panel => panel === event.target || panel.contains(event.target));
      if (index >= 0) select(index);
    });
  }
  function initFinder(root) {
    if (root.dataset.forestReady) return;
    let catalog;
    try { catalog = JSON.parse(root.querySelector('[data-forest-catalog]').textContent); } catch (_) { return; }
    root.dataset.forestReady = 'true';
    const form = root.querySelector('[data-forest-finder-form]');
    const results = root.querySelector('[data-forest-results]');
    const list = root.querySelector('[data-forest-result-list]');
    root.querySelector('[data-forest-finder-submit]').hidden = false;
    form.addEventListener('submit', event => {
      event.preventDefault();
      const values = new FormData(form);
      const source = catalog[values.get('goal')] || catalog.discover;
      const budget = Number(values.get('budget'));
      const matches = source.products.filter(item => item.available && (!budget || item.price <= budget)).slice(0, 3);
      list.replaceChildren();
      matches.forEach(item => {
        const li = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'forest-result';
        link.href = item.url;
        if (item.image) {
          const image = document.createElement('img');
          image.src = item.image; image.alt = ''; image.width = 65; image.height = 78; image.loading = 'lazy';
          link.append(image);
        }
        const info = document.createElement('span');
        const title = document.createElement('strong'); title.textContent = item.title;
        const price = document.createElement('small'); price.textContent = item.money;
        info.append(title);
        if (item.variant) { const variant = document.createElement('small'); variant.textContent = item.variant; info.append(variant); }
        info.append(price); link.append(info); li.append(link); list.append(li);
      });
      const status = root.querySelector('[data-forest-result-status]');
      const message = root.querySelector(matches.length ? '[data-forest-result-success]' : '[data-forest-result-empty]');
      status.replaceChildren(...(message ? [message.content.cloneNode(true)] : []));
      const resultLink = root.querySelector('[data-forest-result-link]');
      if (resultLink) resultLink.href = source.url;
      results.hidden = false;
      root.querySelector('[data-forest-result-title]').focus({ preventScroll: true });
      results.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
    });
  }
  function init(scope) {
    scope.querySelectorAll('[data-forest-shop]').forEach(initShop);
    scope.querySelectorAll('[data-forest-finder]').forEach(initFinder);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('click', event => {
    const link = event.target.closest('a[data-forest-scroll]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    event.preventDefault();
    const header = document.querySelector('.section-header');
    const headerHeight = header ? header.getBoundingClientRect().height : 0;
    const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - headerHeight - 20);
    if (window.location.hash !== link.hash) history.pushState(null, '', link.hash);
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    window.scrollTo({ top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
})();
